import { RootState } from "@/modules/common";

export const selectNotifications = (state: RootState) =>
  state.notifications.notifications;
